import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import helpers from '../../../../../utils/helpers';
import roomProfileModalService from './roomProfileModalService';

const RoomProfileModal = (props) => {
    const {onCancel, onOk} = props || {};
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const localizedStrings = getLocalizedStrings();

    const {formFields, title, submitButton, cancelButton, initialValues} = roomProfileModalService.getFormContent();

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }

        return () => {
            form.resetFields();
        };
    }, []);

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.info('Validate Failed:', error);
        }
    };

    const handleRadioChange = (value, name) => setFormField(name, value);

    const setFormField = (name, key, value) => form.setFieldsValue({[name]: {id: key, value}});

    const handleSelect = async (value, name, option) => {
        const currentValue = form.getFieldValue(name);

        if (currentValue?.value === option.value) return;

        setFormField(name, option.key, option.value);
    };

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='room-profile-mobile'
                title={title}
                closeLabel={localizedStrings[localizationKeys.DC_PAGE_MOBILE_CLOSE_FORM]}
                formFields={formFields}
                initialValues={initialValues}
                onFinish={onFinish}
                onCancel={onCancel}
                submitButton={submitButton}
                cancelButton={cancelButton}
                handleRadioChange={handleRadioChange}
                handleSelect={handleSelect}
                handleChange={handleChange}
            />
        );
    }

    return (
        <Form
            formClassName='room-profile-form'
            containerClassName='room-profile-form-content'
            buttonsClassName='room-profile-form-actions'
            handleRadioChange={handleRadioChange}
            handleSelect={handleSelect}
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formFields}
            cancelButton={cancelButton}
            formInstance={form}
            handleChange={handleChange}
        />
    );
};

export default React.memo(RoomProfileModal);
